import { ReactNode, memo } from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { Card as MuiCard, CardContent as MuiCardContent, Typography, Box } from '@mui/material';

const MuiStyledCard = withStyles((theme: Theme) => ({
  root: {
    height: '100%',
    background: theme.palette.background.paper,
    borderRadius: theme.customComponents.card.borderRadius,
    boxShadow: theme.customComponents.card.boxShadow
  }
}))(MuiCard);

const MuiStyledContent = withStyles((theme: Theme) => ({
  root: {
    padding: 0,
    height: `calc(100% - ${theme.customComponents.card.header.height})`,
    '&:last-child': {
      paddingBottom: '0'
    }
  }
}))(MuiCardContent);

interface Props {
  title?: string;
  content: ReactNode;
}

const Card = ({ title, content }: Props) => {
  const theme = useTheme();

  return (
    <MuiStyledCard>
      {title && (
        <Box py={2} px={3} minHeight={theme.customComponents.card.header.height}>
          <Typography
            sx={{
              [theme.breakpoints.up('md')]: {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }
            }}
            variant="h2"
          >
            {title}
          </Typography>
        </Box>
      )}
      <MuiStyledContent>{content}</MuiStyledContent>
    </MuiStyledCard>
  );
};

export default memo(Card);
